<div
  class="flex w-full overflow-auto sm:flex-wrap hide-scrollbars view-enter-animation"
  [class.sm:justify-center]="isCentered()"
  [class.overflow-hidden]="!initialized()"
  [mobiTracking]="{ name: 'content navigation' }"
>
  @for (contentLink of contentLinks(); let i = $index; track contentLink.sectionId) {
    <div class="mobi-ui-margin-b-sm mobi-ui-padding-r-sm">
      @if (contentLink.sectionId) {
        @if (breakpoint.smAndLarger()) {
          <a
            [attr.data-delay]="i * 100"
            class="content-link-btn mobi-ui-btn-silent !pl-3"
            [betterRouterLink]="formatLink(contentLink)"
          >
            <mobi-ui-icon-major class="!ml-0" name="arrow_lower_right" size="sm" />
            <span class="whitespace-nowrap">{{ contentLink.label }}</span>
          </a>
        }
        @if (!breakpoint.smAndLarger()) {
          <a
            [attr.data-delay]="i * 100"
            class="content-link-btn mobi-ui-btn-silent !pl-3"
            [betterRouterLink]="formatLink(contentLink)"
          >
            <mobi-ui-icon-major class="!ml-0" name="arrow_lower_right" size="sm" />
            <span class="whitespace-nowrap">{{ contentLink.label }}</span>
          </a>
        }
      }
    </div>
  }
  @if (otherLinks() && otherLinks().length > 0) {
    @for (otherLink of otherLinks(); let i = $index; track i) {
      @if (otherLink | extractUrl) {
        @if (breakpoint.smAndLarger()) {
          <a
            [betterRouterLink]="otherLink | extractUrl"
            [target]="otherLink.options?.attributes?.target || '_self'"
            class="mobi-ui-margin-b-sm mobi-ui-padding-r-sm"
            [attr.data-delay]="contentLinks().length * 100 + i * 100"
          >
            <div class="content-link-btn mobi-ui-btn-silent !pl-3">
              <mobi-ui-icon-major class="!ml-0" name="arrow_right" size="sm" />
              <span class="whitespace-nowrap">{{ otherLink.title }}</span>
            </div>
          </a>
        }
        @if (!breakpoint.smAndLarger()) {
          <a
            [betterRouterLink]="otherLink | extractUrl"
            [target]="otherLink.options?.attributes?.target || '_self'"
            class="mobi-ui-margin-b-sm mobi-ui-padding-r-sm"
            [attr.data-delay]="contentLinks().length * 100 + i * 100"
          >
            <div class="content-link-btn mobi-ui-btn-silent !pl-3">
              <mobi-ui-icon-major class="!ml-0" name="arrow_right" size="sm" />
              <span class="whitespace-nowrap">{{ otherLink.title }}</span>
            </div>
          </a>
        }
      }
    }
  }
</div>
@defer (on timer(500ms)) {
  @if (contentLinks().length > 1) {
    <mobi-sticky [links]="contentLinks()" />
  }
}
